import { render } from "./BusinessUnits.vue?vue&type=template&id=56e9d4b0&ts=true"
import script from "./BusinessUnits.vue?vue&type=script&lang=ts"
export * from "./BusinessUnits.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__